<script lang="ts">
  import OVIcon from "app/components/+shared/OVIcon/OVIcon.svelte";
  import cx from "classnames";
  import { tooltip } from "app/actions/tooltip";
  import { Right } from "$components/+shared/OVIcon";

  export let description: string = "";
  export let isDescriptionInline: boolean = false;
  export let reverseOrder: boolean = false;
  export let isSelected: boolean = false;
  export let active: boolean | undefined = undefined;
  export let danger: boolean = false;
  export let tooltipCopy: string = "";
</script>

<div
  class={cx(
    "w-inherit group flex cursor-pointer rounded p-2 text-left hover:bg-black/5 dark:hover:bg-white/7",
    {
      "gap-2.5": !reverseOrder,
      "flex-row-reverse justify-between gap-3.5": reverseOrder,
      "bg-neutral-100 text-neutral-500 dark:bg-white/10 dark:text-white": active,
      "text-neutral-500 dark:text-white": isSelected,
      "text-brand-red dark:text-brand-red": danger,
      "hover:text-neutral-500 dark:hover:text-white": !isSelected && !danger && !active,
      "text-neutral-500/90 dark:text-neutral-400": !isSelected && !danger && !active,
    }
  )}
  class:items-start={description && !isDescriptionInline}
  class:items-center={!description || isDescriptionInline}
  title={tooltipCopy}
  use:tooltip
>
  <slot />

  {#if active !== undefined}
    <span class="ml-auto">
      <OVIcon icon={Right} class="ml-3 shrink-0 opacity-60" />
    </span>
  {/if}
</div>
